import { render, staticRenderFns } from "./projectitem.vue?vue&type=template&id=90f83e78&scoped=true&"
import script from "./projectitem.vue?vue&type=script&lang=js&"
export * from "./projectitem.vue?vue&type=script&lang=js&"
import style0 from "./projectitem.vue?vue&type=style&index=0&id=90f83e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f83e78",
  null
  
)

export default component.exports